cv.TeamPageView = Marionette.LayoutView.extend({
  className : 'page-dashboard',
  
  template: cv.Templates['team/page'],

  regions : {
  },

  bindings : {
  },

  events : {
    'click .export-members' : 'exportMembers',
    'click .export-donations' : 'exportDonations'
  },

  validation: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('TeamPageView initialized.');
  },
  templateHelpers: function(){
    return {
      is_admin : cv.project.get('team.role') == 'admin' ? true : false
    }
  },

  exportMembers: function(e){
    e.preventDefault();

    window.location = cv.api_path + '/teams/' + this.model.get('id') + '/x_export_members?campaign_id=' + cv.campaign.get('id') + '&api_key=' + cv.PRELOADED.api_key;
  },

  exportDonations: function(e){
    e.preventDefault();

    window.location = cv.api_path + '/teams/' + this.model.get('id') + '/x_export_donations?campaign_id=' + cv.campaign.get('id') + '&api_key=' + cv.PRELOADED.api_key;
  },

  onAttach: function(){
    
  }
});